import pick from 'lodash/pick';

import { INPUT_TYPE_CONFIGURATIONS } from '../constants/bootstrapKeys';

/**
 * @param {Object} formNode - Form node descriptor
 * @return {Object} - Form Template Library question descriptor
 */
export default function parseNodeToBankQuestion(serializedFormNode, bootstrap) {
    const question = pick(serializedFormNode, [
        'inputType',
        'label',
        'placeholder',
        'help',
        'description',
        'type',
        'config',
        'logic',
        'urlParamName',
        'code',
    ]);

    if (serializedFormNode.config && serializedFormNode.inputType) {
        const inputTypeConfigurations = bootstrap[INPUT_TYPE_CONFIGURATIONS];
        question.config = pick(
            serializedFormNode.config,
            Object.keys(inputTypeConfigurations[serializedFormNode.inputType] || {}),
        );
    }

    return question;
}
